import { render, staticRenderFns } from "./BaseButtonResponsive.vue?vue&type=template&id=36878e14&scoped=true&"
import script from "./BaseButtonResponsive.vue?vue&type=script&lang=js&"
export * from "./BaseButtonResponsive.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonResponsive.vue?vue&type=style&index=0&id=36878e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36878e14",
  null
  
)

export default component.exports